import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/placeholder_overlay.png'


const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "absolute w-3 opacity-80"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "absolute bg-white opacity-30 h-full w-full" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("img", _mergeProps({
      src: `${_ctx.storageUrl}/mainImage.jpg`,
      class: "w-full h-full",
      style: {"object-fit":"cover"}
    }, _ctx.$attrs), null, 16, _hoisted_1),
    _hoisted_2,
    _hoisted_3
  ], 64))
}